<div class="sidenav-loading" [ngClass]="{ cover: cover() }">
  <div class="lds-dual-ring"></div>
</div>
